// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"693f8c66","139":"4545f3ec","449":"f3db773a","543":"cbedcd72","773":"dac4869d","816":"91a1f215","871":"9d544709"}[chunkId] + ".chunk.css";
};